import React, { useContext, useState } from 'react'
import { Modal, View } from 'oio-react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Route, useHistory, useRouteMatch } from 'react-router-dom'
import uiConstants from 'config/constants/ui'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import PageUIContext from 'src/libraries/contexts/PageUI'
import ThemeContext from 'src/libraries/contexts/Theme'
import VisualEditorTitlebar from '~/Page/components/VisualEditorTitlebar'
import VisualEditorViewport from '~/Page/components/VisualEditorViewport'
import PageContext from '~/Page/libraries/context'
import PageSettings from '~/Page/pages/Settings'

const PageVisualEditor = ({ returnUrl }) => {
   const history = useHistory()
   const match = useRouteMatch()
   const { initiative } = useContext(InitiativeHierarchyContext)

   const [modalIsOpen, setModalIsOpen] = useState(true)
   const theme = useContext(ThemeContext)
   const page = useContext(PageContext)

   return (
      <View
         position="absolute"
         top="0px"
         left="0px"
         right="0px"
         bottom="0px"
         backgroundColor="#1a1a1a">
         <Helmet title={`Visual Editor | ${page?.title}`} />
         <VisualEditorTitlebar
            returnUrl={returnUrl}
            title={page?.title}
         />
         <View
            position="absolute"
            top="89px"
            left="0px"
            right="0px"
            bottom="0px">
            <PageUIContext.Provider
               value={{
                  contentMaxWidth: '1000px[a-e] 1200px[f]',
                  contentPaddingLeft: theme.viewportPaddingLeft,
                  contentPaddingRight: theme.viewportPaddingLeft,
                  contentPaddingVertical: '12px'
               }}>
               <VisualEditorViewport
                  page={page}
                  initiativeId={initiative?.id}
               />
            </PageUIContext.Provider>
         </View>
         <Route path={`${match.path}/settings`}>
            <Modal
               borderRadius="6px"
               width="100%[a-d] 1200px[e-f]"
               height="100%[a-d] 80%[e-f]"
               onCloseComplete={() => {
                  history.push(match.url)
                  setModalIsOpen(true)
               }}
               onCloseTrigger={() => setModalIsOpen(false)}
               open={modalIsOpen}
               overlayBackgroundColor="rgba(30,30,30,0.95)"
               zIndex={uiConstants.zIndexes.tmpSettingsModal + 1}>
               <PageSettings returnUrl={match.url} />
            </Modal>
         </Route>
      </View>
   )
}

PageVisualEditor.propTypes = {
   returnUrl: PropTypes.string.isRequired
}

export default PageVisualEditor
